import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API, errMsg, fmtDate } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { toast } from "sonner";

export default function AdminReports() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("open");
  const [reports, setReports] = useState(null);

  const load = async () => {
    try {
      const { data } = await API.get(`/admin/reports?status=${status}`);
      setReports(data);
    } catch (e) { toast.error(errMsg(e)); }
  };

  useEffect(() => { load(); }, [status]);

  const update = async (r, s) => {
    try {
      await API.put(`/admin/reports/${r._id}`, { status: s });
      toast.success(`Report marked ${s.replace("_", " ")}`);
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div data-testid="admin-reports-page">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
        <h1 className="font-display text-2xl font-bold" data-testid="admin-reports-title">Question reports</h1>
        <Select value={status} onValueChange={setStatus}>
          <SelectTrigger className="w-44" data-testid="reports-status-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            {["open", "in_review", "resolved", "dismissed"].map((s) => (
              <SelectItem key={s} value={s} data-testid={`reports-filter-${s}`}>{s.replace("_", " ")}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {!reports ? <p className="py-16 text-center text-sm text-muted-foreground">Loading…</p> : reports.length === 0 ? (
        <p className="py-16 text-center text-sm text-muted-foreground" data-testid="reports-empty">No {status.replace("_", " ")} reports.</p>
      ) : (
        <div className="space-y-4" data-testid="reports-list">
          {reports.map((r) => (
            <div key={r._id} className="bg-card border border-border rounded-lg p-5" data-testid={`report-${r._id}`}>
              <div className="flex flex-wrap items-center gap-2 mb-2 text-xs text-muted-foreground">
                <span className="font-bold text-primary">{r.question?.qid || "Deleted question"}</span>
                <span>·</span><span className="font-semibold text-foreground">{r.reason}</span>
                <span>·</span><span>{r.user_email}</span>
                <span>·</span><span>{fmtDate(r.created_at)}</span>
              </div>
              <p className="text-sm line-clamp-2 mb-2">{r.question?.stem}</p>
              {r.details && <p className="text-sm text-muted-foreground bg-muted rounded-md p-3 mb-3">"{r.details}"</p>}
              <div className="flex flex-wrap gap-2 mt-3">
                {r.question && (
                  <Button variant="outline" size="sm" data-testid={`report-edit-${r._id}`}
                    onClick={async () => {
                      navigate(`/admin/questions/${r.question_id}`);
                    }}>
                    Open question in editor
                  </Button>
                )}
                {r.status === "open" && <Button size="sm" variant="outline" data-testid={`report-inreview-${r._id}`} onClick={() => update(r, "in_review")}>Mark in review</Button>}
                {r.status !== "resolved" && <Button size="sm" data-testid={`report-resolve-${r._id}`} onClick={() => update(r, "resolved")}>Resolve</Button>}
                {r.status !== "dismissed" && <Button size="sm" variant="ghost" data-testid={`report-dismiss-${r._id}`} onClick={() => update(r, "dismissed")}>Dismiss</Button>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
